module.exports = __webpack_public_path__ + "img/rebuild_huang_mob3.3c1d1d3f.jpg";